export function getSupportedImageFields(fields: FieldDto[]) {
    return fields.filter((f) => {
        return ['string', 'url', 'multi_file'].includes(f.type)
    })
}
